import React, { useRef, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import DocumentPreview from 'srcReact/MessengerPage/components/DocumentPreview'
import { messengerSettings } from 'srcReact/MessengerPage/MessengerSettings'
import ReactionContainer from 'srcReact/components/common2/ReactionContainer'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import MediaImage from 'srcReact/components/common2/MediaImage'
import LinkPreview from 'srcReact/components/common2/LinkPreview'
import Icon from 'srcReact/components/icons/Icon'
import { checkTextAndEmoji, sanitizeMessengerLinks } from 'srcReact/helpers/utils'
import Spinner from 'srcReact/components/common2/Spinner'
import { messengerActions } from 'srcReact/MessengerPage/actions'
import { getParsedMessage, isMessageGiftLink } from 'srcReact/helpers/feedHelper'

export default function Content({
  messageProp,
  showTime,
  showImageModal,
  isMessageAppended,
  isMessageOptionsVisible,
  appendToPrevious,
  appendEmoji,
  handleReactionClick,
  handleOpenPicker,
  messageTime,
  reactionProcessing,
  reactionToProcess,
  showUserModal,
  activeUsers,
  isSender,
  isFileProcessing,
  targetRefs,
  scrollToTarget,
  fromQuickMessenger
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    messenger: { openedConversation, scrollToMessage }
  } = useSelector((state) => state)
  // const ref = useRef(messageProp.id)
  const isFilesOwner = messageProp.id_user === loggedInUser.id
  const {
    id,
    createdAt,
    message,
    origin_message,
    origin_message_id,
    files,
    reactions,
    has_been_deleted,
    messageId,
    fileIds
  } = messageProp

  const [messageContent, setMessageContent] = useState('')
  const [isGifLink, setIsGifLink] = useState(false)

  useEffect(() => {
    if (scrollToMessage.message_id > 0) {
      setTimeout(() => {
        scrollToTarget(scrollToMessage.message_id)
      }, 500)
      setTimeout(() => {
        dispatch(messengerActions.resetScrollToMessage())
      }, 2500)
    }
  }, [scrollToMessage])

  useEffect(() => {
    if (messageProp?.message || messageProp?.content) {
      //apply target  to _blank for all anchor tags
      const parsedMessage = getParsedMessage(messageProp.message || messageProp.content)
      if (parsedMessage) {
        setMessageContent(parsedMessage)
        if (parsedMessage) {
          const anchors = parsedMessage.getElementsByTagName('a')
          if (anchors) {
            Array.from(anchors)?.forEach((a) => {
              a.setAttribute('target', '_blank')
            })
          }

          //check if message is a gif link
          const allLinksAreGifImages = isMessageGiftLink(parsedMessage)
          if (allLinksAreGifImages) {
            setIsGifLink(true)
          }
        }
      }
    }
  }, [messageProp?.message, messageProp?.content])

  // useEffect(() => {
  // const scrollToReplay = document.getElementById(`scrollToMessage#${messageProp?.id}`)
  // if (scrollToReplay) {
  //   scrollToReplay.addEventListener('click', scrollToReplayMessage)
  //   return () => {
  //     scrollToReplay.removeEventListener('click', scrollToReplayMessage)
  //   }
  // }
  // }, [messageProp])

  // const scrollToReplayMessage = (e) => {
  //   e.preventDefault()
  //   ref.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
  // }

  useEffect(() => {
    const chatWindowContainer = document.querySelector('[class*="chatWindow"]')
    if (chatWindowContainer) {
      const elements = chatWindowContainer.querySelectorAll('span[class="mention"]')
      for (let element of elements) {
        element.addEventListener('click', () => clickOnMention(element))
      }
      return () => {
        for (let element of elements) {
          element.removeEventListener('click', () => clickOnMention(element))
        }
      }
    }
  }, [])

  const clickOnMention = (element) => {
    const { dataset } = element
    if (dataset && dataset.id > 0) {
      const user = activeUsers.find((u) => u.id == dataset.id)
      if (user && showUserModal) {
        showUserModal(user, 0)
      }
    }
  }

  const isReply = messageProp.is_reply === 1 && messageProp.origin_message ? true : false

  return (
    <div
      ref={(el) => {
        if (el && messageProp && messageProp.id) {
          targetRefs.current[messageProp.id] = el
        }
      }}
      // id={`scrollToMessage#${messageProp.id}`}
      className={`${styles.messageContainer} ${isSender && styles.senderContainer} ${
        isMessageAppended && styles.appendedMessageContainer
      } ${showTime && styles.appendedMessageContainerWithTime} ${
        isMessageOptionsVisible && styles.messageContainerHovered
      } ${isReply && styles.replyContainer} ${
        openedConversation &&
        openedConversation.conversation.is_group_conversation == 1 &&
        !isSender &&
        styles.groupContainer
      }`}>
      {showTime && (
        <span
          className={`${styles.time} ${
            !isSender &&
            isMessageAppended &&
            openedConversation.conversation.is_group_conversation == 1 &&
            styles.othersTime
          }`}>
          {messageTime}{' '}
        </span>
      )}
      {has_been_deleted === 1 ? (
        <p className={styles.deletedMessage}>{t('messenger.deletedMessageText')}</p>
      ) : (
        <div
          className={`${styles.messageContainer2} ${
            openedConversation &&
            openedConversation.conversation.is_group_conversation == 1 &&
            !isSender &&
            appendToPrevious &&
            styles.groupContainer2
          } ${isSender && styles.senderContainer} ${isFileProcessing ? styles.messageWithProcessingFiles : ''}`}>
          {files && files.length === 0 && !isSender && isReply && (
            <Icon name='reply' size='large24' styleModifier={styles.replyIcon} />
          )}
          {messageContent?.body?.innerHTML && sanitizeMessengerLinks(messageContent.body.innerHTML) && !isGifLink && (
            <p
              className={`${styles.message} ${messageId && messageId.length > 0 && styles.messageInProgress} ${
                isSender && styles.senderMessage
              } ${styles[checkTextAndEmoji(messageContent.body.innerHTML)]}`}
              dangerouslySetInnerHTML={{
                __html: sanitizeMessengerLinks(messageContent.body.innerHTML)
              }}
            />
          )}
          {isFileProcessing && (
            <div className={`${styles.processingFileText}`}>
              <span>{t('messenger.processingFiles')}</span> <Spinner />
            </div>
          )}
          <LinkPreview  
            fromQuickMessenger={fromQuickMessenger}
            data={messageProp.message}
            containerCSS={`${styles.linkPreviewContainer} ${isGifLink && styles.gifLinkPreviewContainer}`}
          />
          {files && files.length === 0 && isSender && isReply && (
            <Icon name='send-reply' size='large24' styleModifier={styles.senderReplyIcon} />
          )}
        </div>
      )}
      {files && files.length > 0 && (
        <div
          className={`${styles.fileContainer} ${
            openedConversation &&
            openedConversation.conversation.is_group_conversation == 1 &&
            !isSender &&
            appendToPrevious &&
            styles.fileContainer2
          } ${isSender && styles.senderContainer}`}>
          {files.map((file, index) => {
            const fileName = file.name
            const extension = (fileName && fileName.split('.').pop()) || ''

            return !messengerSettings.ACCEPTED_IMAGE_TYPES.includes(extension.toLowerCase()) ? (
              <button
                type='button'
                aria-label={file.name}
                key={file.id}
                className={styles.imageButton}
                onClick={() => showImageModal(file, index, files, isFilesOwner, messageProp.id)}>
                <DocumentPreview
                  key={file.id}
                  fileName={fileName}
                  extension={extension.toLowerCase()}
                  showOptions={false}
                />
              </button>
            ) : (
              <MediaImage
                file={file}
                index={index}
                files={files}
                isFilesOwner={isFilesOwner}
                entityId={messageProp.id}
                showImageModal={showImageModal}
                size='medium'
                parentElementId='chatWindow'
              />
            )
          })}
        </div>
      )}
      {reactions && reactions.length > 0 && (
        <ReactionContainer
          messageId={messageProp.id}
          reactions={reactions}
          appendEmoji={appendEmoji}
          handleOpenPicker={handleOpenPicker}
          handleReactionClick={handleReactionClick}
          loggedInUser={loggedInUser}
          isProcessing={reactionProcessing}
          reactionToProcess={reactionToProcess}
          className={`${styles.reactionClassName} ${isReply && styles.replyClassName} ${isSender && styles.isSender} ${
            openedConversation &&
            openedConversation.conversation.is_group_conversation == 1 &&
            isMessageAppended &&
            styles.isMessageAppended
          }`}
          reactionButtonClassName={styles.reactionButtonClassName}
          isEmojiPicker={false}
          fromMessenger={true}
        />
      )}
    </div>
  )
}
